export default __webpack_public_path__ + "static/media/mancora-sunset_pool_view.16f1dae7.jpg";